import script from "./BannerComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./BannerComponent.vue?vue&type=script&setup=true&lang=js"

import "./BannerComponent.vue?vue&type=style&index=0&id=3526a820&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/claims-portal/claims-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3526a820"]])

export default __exports__